import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

export default function Forbidden() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center py-20 px-4 sm:px-6 lg:px-8 bg-slate-50">
      <SEO
        title="403 - Adgang nægtet | Transport4U"
        description="Du har ikke adgang til denne ressource. Gå tilbage til forsiden eller kontakt Transport4U."
      />

      <div className="max-w-xl w-full text-center space-y-6 bg-white p-8 sm:p-12 rounded-3xl border border-slate-200 shadow-sm">
        <div className="inline-flex h-20 w-20 items-center justify-center rounded-2xl bg-amber-50 text-amber-600 ring-8 ring-amber-50/50">
          <i className="fa-solid fa-lock text-3xl" aria-hidden="true" />
        </div>

        <div className="space-y-2">
          <span className="text-xs font-bold uppercase tracking-widest text-amber-600">
            Fejlkode 403
          </span>
          <h1 className="text-3xl sm:text-4xl font-black text-slate-900 tracking-tight">
            Adgang forbudt
          </h1>
          <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
            Du har ikke tilladelse til at se denne side eller ressource. Benyt venligst knapperne herunder for at navigere tilbage.
          </p>
        </div>

        <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-3.5">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-sky-600 hover:bg-sky-500 text-white font-bold text-sm transition-colors shadow-xs"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Tilbage til forsiden</span>
          </Link>

          <Link
            to="/kontakt"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-800 font-bold text-sm transition-colors"
          >
            <span>Kontakt Transport4U</span>
            <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
          </Link>
        </div>

        <div className="pt-6 border-t border-slate-100 text-xs text-slate-500">
          Har du spørgsmål? Ring på{' '}
          <a href="tel:+4550352035" className="font-bold text-sky-600 hover:underline whitespace-nowrap">
            50 35 20 35
          </a>
        </div>
      </div>
    </div>
  )
}
